module.exports = __webpack_public_path__ + "static/media/figtree-latin-500.81bd5eb4.woff2";